module.exports = __webpack_public_path__ + "img/howto_ico04.3a658401.png";